import React from "react";
import { useNavigate } from "react-router-dom";

const LawnMowingHub = () => {
  const navigate = useNavigate();

  return (
    <div style={{ padding: "60px 20px", textAlign: "center" }}>
      <h1
        style={{
          fontSize: "2.8rem",
          color: "#1b5e20",
          marginBottom: "15px",
          fontWeight: "800",
        }}
      >
        🟢 Lawn Mowing
      </h1>

      <p
        style={{
          fontSize: "1.2rem",
          maxWidth: "650px",
          margin: "0 auto 50px",
          color: "#444",
        }}
      >
        Buy or swap lawn mowing clients, rounds.
      </p>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
          gap: "30px",
          maxWidth: "1000px",
          margin: "0 auto",
        }}
      >
        {/* CLIENTS */}
        <HubCard
          title="Clients"
          description="Buy individual lawn mowing clients"
          onClick={() =>
            navigate("/listings?category=Lawn+Mowing")
          }
        />

        {/* SWAPS */}
        <HubCard
          title="Swaps"
          description="Swap lawn mowing clients with other operators"
          onClick={() =>
            navigate("/swaps?category=Lawn+Mowing")
          }
        />

        {/* ROUNDS */}
        <HubCard
          title="Rounds"
          description="Buy lawn mowing rounds"
          onClick={() =>
            navigate("/lawn-mowing/rounds")
          }
        />

        {/* BUSINESSES */}
<HubCard
  title="Businesses"
  description="Lawn & gardening businesses for Sale"
  onClick={() =>
    navigate("/lawn-mowing/business")
  }
/>

  
      </div>
    </div>
  );
};

/* ------------------------------------
   Reusable Card Component
------------------------------------ */
const HubCard = ({ title, description, onClick }) => {
  return (
    <div
      onClick={onClick}
      style={{
        background: "#e8f5e9",
        borderRadius: "16px",
        padding: "30px",
        cursor: "pointer",
        boxShadow: "0 6px 15px rgba(0,0,0,0.1)",
        transition: "transform 0.2s ease",
      }}
      onMouseEnter={(e) =>
        (e.currentTarget.style.transform = "translateY(-6px)")
      }
      onMouseLeave={(e) =>
        (e.currentTarget.style.transform = "translateY(0)")
      }
    >
      <h3
        style={{
          fontSize: "1.6rem",
          color: "#1b5e20",
          marginBottom: "10px",
        }}
      >
        {title}
      </h3>

      <p style={{ fontSize: "1rem", color: "#444" }}>
        {description}
      </p>
    </div>
  );
};

export default LawnMowingHub;
